
import template1 from '../../../../../../assets/svg/timelineTemplates/template1.svg';
import template2 from '../../../../../../assets/svg/timelineTemplates/template2.svg';
import template3 from '../../../../../../assets/svg/timelineTemplates/template3.svg';
import template4 from '../../../../../../assets/svg/timelineTemplates/template4.svg';
import template5 from '../../../../../../assets/svg/timelineTemplates/template5.svg';
import template6 from '../../../../../../assets/svg/timelineTemplates/template6.svg';
import template7 from '../../../../../../assets/svg/timelineTemplates/template7.svg';
import template8 from '../../../../../../assets/svg/timelineTemplates/template8.svg';
import template9 from '../../../../../../assets/svg/timelineTemplates/template9.svg';
import template10 from '../../../../../../assets/svg/timelineTemplates/template10.svg';
import template11 from '../../../../../../assets/svg/timelineTemplates/template11.svg';
import template12 from '../../../../../../assets/svg/timelineTemplates/template12.svg';
import template13 from '../../../../../../assets/svg/timelineTemplates/template13.svg';
import template14 from '../../../../../../assets/svg/timelineTemplates/template14.svg';
import template15 from '../../../../../../assets/svg/timelineTemplates/template15.svg';
import template16 from '../../../../../../assets/svg/timelineTemplates/template16.svg';
import template17 from '../../../../../../assets/svg/timelineTemplates/template17.svg';
import template18 from '../../../../../../assets/svg/timelineTemplates/template18.svg';

const templateSvgsPath = [
    { _id: "template1", label: "Template 1", style: { dotColor: "#7331FF", dotBg: "#FFF", line: "dotted" } },
    { _id: "template2", label: "Template 2", style: { dotColor: "#E27841", dotBg: "#FFF", line: "dotted" } },
    { _id: "template3", label: "Template 3", style: { dotColor: "#121212", dotBg: "#FFF", line: "dotted", boxShadow: "0px 4px 14px rgba(125, 132, 146, 0.294)", border: "1px solid rgba(125, 132, 146, 0.294)", borderRadius: "3px" } },
    { _id: "template4", label: "Template 4", style: { dotColor: "#121212", dotBg: "#FFF", line: "dotted" } },
    { _id: "template5", label: "Template 5", style: { dotColor: "#7331FF", dotBg: "#7331FF", line: "dotted" } },
    { _id: "template6", label: "Template 6", style: { dotColor: "#7331FF", dotBg: "#7331FF", line: "dotted" } },
    { _id: "template13", label: "Template 13", style: { dotColor: "#7331FF", dotBg: "#7331FF", line: "dotted" } },
    { _id: "template14", label: "Template 14", style: {} },
    { _id: "template15", label: "Template 15", style: {} },
    { _id: "template16", label: "Template 16", style: {} },
    { _id: "template17", label: "Template 17", style: {} },
    { _id: "template18", label: "Template 18", style: {} },
    { _id: "template7", label: "Template 7", style: { dotColor: "#27AE60", dotBg: "#7331FF", line: "dotted" } },
    { _id: "template8", label: "Template 8", style: { dotColor: "#27AE60", dotBg: "#7331FF", line: "dotted" } },
    { _id: "template9", label: "Template 9", style: { dotColor: "#27AE60", dotBg: "#7331FF", line: "dotted" } },
    { _id: "template10", label: "Template 10", style: { dotColor: "#27AE60", dotBg: "#7331FF", line: "dotted" } },
    { _id: "template11", label: "Template 11", style: { dotColor: "#27AE60", dotBg: "#FFF", line: "dotted" } },
    { _id: "template12", label: "Template 12", style: { dotColor: "#27AE60", dotBg: "#7331FF", line: "dotted" } }
];

const templateIcons: Record<string, string> = {
    template1, template2, template3, template4, template5, template6, 
    template7, template8, template9, template10, template11, template12,
    template13, template14, template15, template16, template17, template18,
};

export const templateSvgs = templateSvgsPath.map(list => ({
    ...list,
    icon: templateIcons[list._id] || null,
}));
